const routes = [
    {
        path: '/',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                name: 'ConfigDominio',
                path: '/dominios/configurar',
                component: () => import('../views/ConfigDominioView'),
            },
        ]
    }
]

export default routes